var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"border":"0"},attrs:{"src":`https://www.google.com/maps?width=100%25&height=600&hl=en&q=${_vm.address}&t=&z=14&ie=UTF8&iwloc=B&output=embed`,"width":_vm.width,"height":_vm.height,"frameborder":"0","allowfullscreen":"","aria-hidden":"false","tabindex":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }